import CategoriesItem from "./CategoryItem";

export default CategoriesItem;
